import { ViewChild, Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SaldoAdiantamento } from '../../_models';

@Component({
  selector: 'app-popup-adiantamentos',
  templateUrl: './popup-adiantamentos.component.html',
  styleUrls: ['./popup-adiantamentos.component.css']
})
export class PopupAdiantamentosComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PopupAdiantamentosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaldoAdiantamento[]) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    
  }

  VincularAdiantamentos(){
    let dataChecked = this.data.filter(d => d.checked);
    this.dialogRef.close(dataChecked);

  }
  
  closePopup(){
    this.dialogRef.close()
    this.dataSource = new MatTableDataSource();
  }

  displayedColumns: string[] = ['checked', 'numSolAdiantamento', 'referencia', 'montante', 'descDivisao'];
  dataSource = new MatTableDataSource<SaldoAdiantamento>(this.data);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
}
